import React from 'react';
import { Play } from 'lucide-react';
import GameArtwork from '../../components/GameArtwork';
import { HOOKS, hook } from '../../lib/domHooks';

/**
 * Zümrüt şemasının oyun kartı.
 *
 * `variant="feature"` vitrin kartıdır: altın çerçeveli, oyun adı büyük
 * harflerle ve altında "HEMEN OYNA" bandıyla. Varsayılan varyant listelerde
 * kullanılan kare karttır — görselin altında oyun adı ve sağlayıcı.
 */
const ZumrutGameCard = ({ game, onPlay, variant = 'default' }) => {
  const play = () => onPlay?.(game);
  const onKeyDown = (event) => { if (event.key === 'Enter') play(); };

  if (variant === 'feature') {
    return (
      <div {...hook(HOOKS.GAME_CARD)} className="zumrut-feature" onClick={play} role="button" tabIndex={0} onKeyDown={onKeyDown}>
        <div className="zumrut-feature-art">
          <GameArtwork src={game.img || game.image} alt={game.name} />
        </div>
        <div className="zumrut-feature-name">{game.name}</div>
        <div className="zumrut-feature-cta">Hemen Oyna</div>
      </div>
    );
  }

  return (
    <div {...hook(HOOKS.GAME_CARD)} className="zumrut-card" onClick={play} role="button" tabIndex={0} onKeyDown={onKeyDown}>
      <div className="zumrut-card-art">
        {game.new && (
          <span
            className="zumrut-card-badge"
            style={{ background: 'var(--pusu-gold)', color: 'var(--pusu-on-accent)' }}
          >
            YENİ
          </span>
        )}
        {!game.new && game.hot && (
          <span className="zumrut-card-badge" style={{ background: '#c62e31' }}>POPÜLER</span>
        )}
        <GameArtwork src={game.img || game.image} alt={game.name} />
        <span className="zumrut-card-play">
          <span
            className="zumrut-btn zumrut-btn-gold"
            style={{ width: 46, height: 46, padding: 0, gap: 0 }}
          >
            <Play size={18} fill="#fff" />
          </span>
        </span>
      </div>
      <div className="zumrut-card-name">{game.name}</div>
      <div className="zumrut-card-provider">{game.provider}</div>
    </div>
  );
};

export default ZumrutGameCard;
